module.exports = __webpack_public_path__ + "static/media/logo.76afe40d.png";